/* eslint-disable no-case-declarations */
import { BellOutlined } from '@ant-design/icons';
import { Badge, Popover, Typography } from 'antd';
import { memo, useEffect, useState } from 'react';
import ThongBaoService from 'src/services/ThongBao.service';
import NotificationPopover from './NotificationPopover';

const sv = new ThongBaoService();

function Notification() {
  const [open, setOpen] = useState<boolean>(false);
  // const [newItem, setNewItem] = useState<INotification>();
  // const { message, isAuth, onSubscribe, onUnSubscribe } = useSocket();
  // const { user } = useUser();
  // const { changeUnreadNotification, unreadNotification } = useUnread();
  const [chuaXem, setChuaXem] = useState<number>(0);

  useEffect(() => {
    fetchThongBaoChuaXem();
  }, []);

  const fetchThongBaoChuaXem = async () => {
    try {
      const data = await sv.soChuaXem();
      setChuaXem(data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Popover
      placement="bottomRight"
      title={<Typography.Title level={4}>Thông báo</Typography.Title>}
      trigger="click"
      content={
        <NotificationPopover
          onClose={() => setOpen(false)}
          onDaXem={(daXem: number) => setChuaXem((prev) => prev - daXem)}
        />
      }
      onOpenChange={(open) => {
        setOpen(open);
        // open && changeUnreadNotification(0);
      }}
      arrow={false}
      // overlayClassName="custom-popover"
      open={open}
    >
      <Badge className="badge-custom" count={chuaXem} offset={[-12, 8]}>
        <div className="icon-wrapper">
          {/* <Tooltip title="Thông báo"> */}
          <BellOutlined style={{ fontSize: 20, color: 'var(--colorPrimary)' }} />
          {/* </Tooltip> */}
        </div>
      </Badge>
    </Popover>
  );
}

export default memo(Notification);
